export default __webpack_public_path__ + "static/media/menu-help-large_darkGray3.3ccf28d9.svg";